import { Keyword } from './KeywordFormSection';

export const errorMessages: Record<string, string> = {
  emptyKeyword: 'Label cannot be empty',
  duplicateKeyword: 'Label already used. Please enter a unique label',
};

const validateKeyword = (value: string, fields: Keyword[]) => {
  const trimmedWord = value.trim();
  if (!trimmedWord) return 'Label cannot be empty';

  const exists = fields.some((field) => field.value === trimmedWord);

  if (exists) {
    return 'Label already used. Please enter a unique label';
  }

  return true;
};

export { validateKeyword };
